import React, { useEffect, useMemo, useState } from 'react';
import { Button, ButtonGroup, Form, Modal } from 'react-bootstrap';

const AssemblyExportModal = ({ show, columns, defaultVisibility, onHide, onExport }) => {
  const [format, setFormat] = useState('excel');
  const [selectedColumns, setSelectedColumns] = useState({});

  useEffect(() => {
    if (!show) return;
    setFormat('excel');
    setSelectedColumns(Object.fromEntries(columns.map((column) => [
      column.key,
      column.key === 'JobNumber' || defaultVisibility[column.key] !== false,
    ])));
  }, [columns, defaultVisibility, show]);

  const selectedCount = useMemo(
    () => columns.filter((column) => selectedColumns[column.key]).length,
    [columns, selectedColumns]
  );

  const selectAll = (selected) => setSelectedColumns(Object.fromEntries(
    columns.map((column) => [column.key, selected || column.key === 'JobNumber'])
  ));

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Export / Print Assembly Schedule</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>Format</Form.Label>
        <ButtonGroup className="d-flex mb-4">
          {[
            ['excel', 'file-earmark-excel', 'Excel'],
            ['pdf', 'file-earmark-pdf', 'PDF'],
            ['print', 'printer', 'Print'],
          ].map(([value, icon, label]) => (
            <Button
              key={value}
              variant={format === value ? 'primary' : 'outline-primary'}
              onClick={() => setFormat(value)}
            >
              <i className={`bi bi-${icon} me-2`} />{label}
            </Button>
          ))}
        </ButtonGroup>

        <div className="assembly-export-column-header">
          <Form.Label className="mb-0">Columns ({selectedCount} selected)</Form.Label>
          <div>
            <Button variant="link" size="sm" onClick={() => selectAll(true)}>Select all</Button>
            <Button variant="link" size="sm" onClick={() => selectAll(false)}>Clear</Button>
          </div>
        </div>
        <div className="assembly-export-columns">
          {columns.map((column) => (
            <Form.Check
              key={column.key}
              id={`assembly-export-${column.key}`}
              label={column.label}
              checked={Boolean(selectedColumns[column.key])}
              disabled={column.key === 'JobNumber'}
              onChange={(event) => setSelectedColumns((current) => ({
                ...current,
                [column.key]: event.target.checked,
              }))}
            />
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button onClick={() => onExport({ format, selectedColumns })} disabled={selectedCount === 0}>
          {format === 'print' ? 'Open Print Preview' : `Export ${format.toUpperCase()}`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssemblyExportModal;
